import axios from 'axios'
import HTTP from './http'

export default {
    getList: params => axios.get(HTTP.ES_LOG, { params })
}
